import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`

const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 300px;
  background: ${({ theme }) => theme.secondaryBackground};
  border-left: 3px solid ${({ theme }) => theme.primary};
  z-index: 1000;
  transform: translateX(${props => props.$isOpen ? '0' : '100%'});
  transition: transform 0.3s ease;
  padding: 2.0em 1.5em 0;
  font-size: 1.15em;
  overflow-y: auto;
`

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 0;
  
  &:before, &:after {
    content: '';
    position: absolute;
    width: 24px;
    height: 2px;
    background: #bdc3c7;
    top: 11px;
    left: 0;
  }
  
  &:before {
    transform: rotate(45deg);
  }
  
  &:after {
    transform: rotate(-45deg);
  }
`

const BurgerButton = styled.button`
  position: absolute;
  width: 36px;
  height: 30px;
  right: 0px;
  top: 0px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 998;
  
  span {
    display: block;
    width: 100%;
    height: 4px;
    background: ${({ theme }) => theme.primary};
    margin-bottom: 6px;
    transition: background 0.3s ease;
    
    &:hover {
      background: ${({ theme }) => theme.secondary};
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const Drawer = ({ isOpen, onStateChange, children, right }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const handleClose = () => {
    onStateChange({ isOpen: false })
  }

  const handleToggle = () => {
    onStateChange({ isOpen: !isOpen })
  }

  return (
    <>
      <BurgerButton onClick={handleToggle}>
        <span />
        <span />
        <span />
      </BurgerButton>
      <DrawerOverlay $isOpen={isOpen} onClick={handleClose} />
      <DrawerContainer $isOpen={isOpen}>
        <CloseButton onClick={handleClose} />
        {children}
      </DrawerContainer>
    </>
  )
}

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onStateChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  right: PropTypes.bool
}

export default Drawer
